
import { AuthService } from "@/services";
import { DashboardIframeData } from "@/utils/dashboard/dashboard-iframe-data";
import { DashboardItem } from "@/utils/dashboard/dashboard-item";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	data(){
		return {
			data: new DashboardIframeData()
		};
	},
	props: {
		item: {
			type: Object as ()=>DashboardItem,
			required: true
		},
		title: {
			type: [String, Object as ()=>TranslateResult],
			required: true
		},
	},
	computed: {
		isDevMode():boolean{
			return AuthService.isDevModeEnabled;
		}
	},
	watch: {
		item: {
			immediate: true,
			handler(){
				if (!this.item.Data){
					this.data = new DashboardIframeData();
					return;
				}
				this.data = new DashboardIframeData(this.item.Data.getJSON());
			}
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		confirm(){
			this.item.Data = this.data;
			this.$emit("confirm", this.item);
			this.close();
		}
	},
	i18nEx: {
		componentPrefix: "components.dashboard"
	}

});
